module.exports = __webpack_public_path__ + "static/media/Alan_Resume.10f47838.pdf";